import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import qs from 'querystring';

class ConfigAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'account';

	/**
	 * Lấy context theo sid khi đăng nhập vào từ amis
	 */
	getContext(param) {
		let queryString = qs.stringify(param);
		let request = {
			url: [this.getAPIUrl(), '/context?', queryString].join(''),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Lấy thông tin phân quyền theo chi nhánh
	 * Nếu không truyền thì sẽ đùng chi nhánh trong context
	 */
	getPermission(orgId) {
		var url = [this.getAPIUrl(), 'permission'];
		if (orgId) {
			url.push(orgId);
		}
		let request = {
			url: url.join('/'),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Đăng xuất khỏi ứng dụng
	 */
	logoff() {
		let request = {
			url: [this.getAPIUrl(), 'logoff'].join('/'),
		};

		return httpClient.postAsync(request);
	}

	/**
	 * Đăng xuất khỏi ứng dụng
	 */
	login(payload) {
		let request = {
			url: [this.getAPIUrl(), 'login'].join('/'),
			data: payload
		};

		return httpClient.postAsync(request);
	}

	/**
	 * Đổi mật khẩu
	 */
	changePassword(payload) {
		let request = {
			url: [this.getAPIUrl(), 'password'].join('/'),
			data: payload
		};

		return httpClient.patchAsync(request);
	}

	/**
	 * Check phiên đăng nhập
	 */
	ping() {
		let request = {
			url: [this.getAPIUrl(), 'ping'].join('/'),
		};

		return httpClient.getAsync(request);
	}
	
	getUserInfoLogin(){
		let request = {
			url: [this.getAPIUrl(), 'check-enable-2fa'].join('/')
		};
		return httpClient.getAsync(request);
	}
	enableTwoFA(){
		let request = {
			url: [this.getAPIUrl(), 'enable-2fa'].join('/')
		};
		return httpClient.getAsync(request);
	}
	verify2FA(payload){
		let request = {
			url: [this.getAPIUrl(), 'verify-2fa'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
	disable2FA(payload){
		let request = {
			url: [this.getAPIUrl(), 'disable-2fa'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
}

export default new ConfigAPI();
